import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './assets/i18n/en.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: translationEN,
    },
  },
  fallbackLng: 'en',
});

export default i18n;
